import { render, staticRenderFns } from "./checkDistrictManage.vue?vue&type=template&id=638222ff&scoped=true&"
import script from "./checkDistrictManage.vue?vue&type=script&lang=js&"
export * from "./checkDistrictManage.vue?vue&type=script&lang=js&"
import style0 from "./checkDistrictManage.vue?vue&type=style&index=0&id=638222ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638222ff",
  null
  
)

export default component.exports